var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBarLibrary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Media Library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/Text-Button/Enabeled/Left-Icon",
    transform: "translate(-1.000000, -1.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Media-Library",
    transform: "translate(1.833333, 1.814815)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    strokeWidth: 1.142,
    points: "11.4429784 12.2825034 6.96072531 14.9374417 7.03865741 9.50685185"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    strokeWidth: 1.5,
    points: "0.00601851852 19.0254733 18.4111111 19.0254733 18.4111111 5.43994513 0.00601851852 5.43994513"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    strokeWidth: 1.5,
    points: "0.00640432099 3.88621399 0.00640432099 2.71982167 18.4114969 2.71982167 18.4114969 3.88621399"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-6",
    strokeWidth: 1.5,
    points: "0 1.16639232 0 0 18.404321 0 18.404321 1.16639232"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarLibrary);
export default __webpack_public_path__ + "static/media/SideBarLibrary.eeb6cb37bbc5179de05a7e3e79382da5.svg";
export { ForwardRef as ReactComponent };